import { AlertCircle, CheckCircle2, Copy, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { QrCode } from "./QrCode";

interface UtmResultProps {
  readonly url: string;
  readonly copied: boolean;
  readonly saveError: string | null;
  readonly onCopy: () => void;
}

/** URL com UTM gerada: copiar, abrir e QR Code. */
export function UtmResult({ url, copied, saveError, onCopy }: UtmResultProps): JSX.Element {
  return (
    <section className="overflow-hidden rounded-xl border border-border bg-card" aria-labelledby="section-utm-result">
      <div className="flex items-center gap-2.5 border-b border-border bg-[hsl(var(--surface-raised)/0.4)] px-5 py-4">
        <ExternalLink size={14} className="text-muted-foreground" />
        <h2 id="section-utm-result" className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">
          URL gerada
        </h2>
      </div>
      <div className="space-y-4 p-5">
        <div className="rounded-lg border border-[hsl(var(--border-strong))] bg-[hsl(var(--surface-raised))] p-4">
          <p className="break-all font-mono text-sm leading-relaxed text-foreground">{url}</p>
        </div>
        <div className="flex items-center gap-3">
          <Button type="button" variant="default" onClick={onCopy}>
            {copied ? <CheckCircle2 size={15} /> : <Copy size={15} />}
            {copied ? "Copiado!" : "Copiar URL"}
          </Button>
          <a href={url} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground">
            <ExternalLink size={14} />
            Abrir URL
          </a>
        </div>
        {saveError && (
          <p role="alert" className="flex items-center gap-2 rounded-lg border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive">
            <AlertCircle size={15} />
            {saveError}
          </p>
        )}
        <QrCode value={url} label="QR Code da URL com UTM" />
      </div>
    </section>
  );
}
